module.exports = __webpack_public_path__ + "media/images/matchdaySelector__md1-0e0ef70618087123134049f04670f959.png";